<template>
    <div class="coupon_content">
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)">我的账号</li>
                <li @click="orderjump(2)">地址管理</li>
                <li class="active">我的优惠券</li>
            </ul>
        </div>
        <div class="coupon_select_content">
            <Select v-model="status" style="width:200px" @on-change="statusChange">
                <Option :value="1">未使用</Option>
                <Option :value="2">已失效</Option>
            </Select>
        </div>
        <div class="coupon_list_content">
            <ul>
                <li :class="{'no': item.usestatus == 1 || item.timestatus == 2}" v-for="(item, index) in couponlist" :key="index">
                    <div class="coupon_list_main" :style="{backgroundImage: item.usestatus == 1 ? 'url(static/images/coupon_used.png)' : (item.timestatus == 2 ? 'url(static/images/coupon_invalid.png)' : '')}" @click="getCouponinfo(item)">
                        <div class="coupon_list_left">
                            <span>¥{{item.cost}}</span>
                            <small v-if="item.limitcost > 0">满{{item.limitcost}}元可用</small>
                            <small v-else>无限制</small>
                        </div>
                        <div class="coupon_list_right">
                            <div class="coupon_list_name"><h3>{{item.name}}</h3></div>
                            <div class="coupon_list_label">
                                <span v-for="(j, sign) in item.goodsrangevalue" :key="sign" v-if="sign < 5">{{j}}</span>
                                <span style="cursor: pointer" v-if="item.goodsrangevalue.length > 5">更多</span>
                            </div>
                            <div class="coupon_list_time"><span>使用时间：{{item.sdate}}<small v-if="item.sdate != ''">-</small>{{item.edate}}</span></div>
                            <div class="coupon_list_explain"><span>使用说明：{{item.instructions}}</span><i class="icon iconfont icon-icon_zhankai_xiangxia1" v-if="item.instructions != ''"></i></div>
                        </div>
                    </div>
                    <div class="coupon_list_btn">
                        <span class="receive" @click="couponBtn(1, item.id)" v-if="item.canget > 0">立即领取</span>
                        <span class="use" @click="couponBtn(2)" v-else>去使用</span>
                        <small>剩余{{item.yucount}}张</small>
                    </div>
                </li>
            </ul>
        </div>
        <SeeCoupon :couponShow="couponShow" :couponinfo="couponinfo" @couponCancel="couponCancel"></SeeCoupon>
    </div>
</template>

<script>
import api from '@/request/api.js'
import SeeCoupon from '@/components/component/popup/seecoupon.vue'
export default {
    components: {SeeCoupon},
    data() {
        return {
            couponShow: false, // 查看优惠券信息弹窗
            couponinfo: {}, // 点击选中优惠券信息
            couponlist: [], // 优惠券列表
            status: 1, // 1 未使用 2 已失效
        }
    },
    methods: {
        getInfo () { // 获取信息
            this.http.post(api.mycoupon, {status: this.status})
            .then(response => {
                console.log(response.data.msg)
                this.couponlist = response.data.msg.juanlist
            })
            .catch(error => {
                console.log(error);
            })
        },
        couponBtn (sign, id) { // 去使用按钮
            if (sign == 1) {
                this.getcoupon(id)
            } else {
                this.$router.push({
                    name: "商品",
                    params: {
                        type: 0
                    }
                })
            }
        },
        getCouponinfo (item) { // 点击获取当前优惠券信息
            this.couponinfo = item
            this.couponShow = true
        },
        couponCancel () { // 关闭查看优惠券信息弹窗
            this.couponShow = false
        },
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Accounts'
            } else if (sign == 2) {
                link = '/Address'
            } else {
                link = '/MyCoupon'
            }
            this.$router.push(link)
        },
        statusChange () { // 搜索状态
            this.getInfo()
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.coupon_select_content {
    padding: 20px 20px 0;
}

</style>


// WEBPACK FOOTER //
// src/components/views/member/mycoupon.vue